/**
 * FileGroupHeader — Source-file section divider with inline rule.
 * Uppercase file name with a horizontal line extending to the right.
 */

interface FileGroupHeaderProps {
    name: string;
}

export function FileGroupHeader({ name }: FileGroupHeaderProps) {
    return (
        <div className="flex items-center gap-2 px-2.5 pt-4 pb-1 first:pt-0">
            <span className="min-w-0 shrink truncate text-[11px] font-semibold tracking-wider text-quaternary uppercase">{name}</span>
            <div className="h-px flex-1 bg-secondary" />
        </div>
    );
}
